import React from "react";
import XiniuChat from "./sections/XiniuChat";
import Trends from "./sections/Trends";
import Benchmark from "./sections/Benchmark";
import IndexPopup from "./IndexPopup";

export default function Index() {
  return <>
    <IndexPopup />
    <XiniuChat />
    <Trends />
    <Benchmark />
  </>
}
